import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ClientIdInterceptor } from './client-api.interceptor';
import { HasClientPermissionDirective } from './has-client-permission.directive';
import { IfClientPermissionDirective } from './if-client-permission.directive';
import { ActiveClientDirective } from './active-client.directive';
import { CWT_AUTH_LISTENER } from '@cawita/core-front/auth';
import { ClientAuthListener } from './client-auth.listener';

@NgModule({
  declarations: [
    HasClientPermissionDirective,
    IfClientPermissionDirective,
    ActiveClientDirective,
  ],
  exports: [
    HasClientPermissionDirective,
    IfClientPermissionDirective,
    ActiveClientDirective,
  ],
  imports: [
    CommonModule
  ]
})
export class SharedClientModule {
  static forRoot(): ModuleWithProviders<SharedClientModule> {
    return {
      ngModule: SharedClientModule,
      providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ClientIdInterceptor, multi: true },
        { provide: CWT_AUTH_LISTENER, useClass: ClientAuthListener, multi: true }
      ]
    }
  }
}
